// App.js
import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { silverTheme } from "./GMapSilverTheme";
import { useSelector } from "react-redux";
import { ChartLoader } from "../components/ShimmerLoader";
import { getSurveyCountDistrictWiseForMap } from "../services/urls";
import API from "../services/apiMiddleware";

// Container style for the map
const containerStyle = {
  width: "100%",
  height: "400px",
};

const App = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAk4_RjGS0QBVi6Waj-f2Qd0bK3gxuL4FU", // Replace with your actual API key
    libraries: ["visualization"],
  });

  const heatmapLayerRef = useRef(null);
  const [mapData, setMapData] = useState([]);
  const [mapLatLng, setMapLatLng] = useState([]);

  const globalFilters = useSelector(
    (state) => state.filterPayload.globalFilters
  );
  const communityId = useSelector((state) => state.communityData.communityId);

  useEffect(() => {
    if (globalFilters != null) {
      fetchOverviewData(globalFilters);
    } else {
      fetchOverviewData(globalFilters);
    }

    let requestBody = {
      communityId,
    };

    if (globalFilters != null) {
      requestBody = { ...requestBody, globalFilters };
    }
  }, [globalFilters]);

  useEffect(() => {
    if (mapData.length > 0) {
      onLoad();
    }
  }, [mapData, isLoaded]);

  const fetchOverviewData = async (filterPayload) => {
    let requestBody = {
      communityId,
    };

    if (filterPayload && Object.keys(filterPayload).length > 0) {
      requestBody.globalFilters = filterPayload;
    }

    API.post(getSurveyCountDistrictWiseForMap, requestBody)
      .then(({ data }) => {
        const heatMapdata = data.data;
        let aMapData = [];
        heatMapdata.forEach((e) => {
          if (e.coordinates && e.coordinates[0] && e.coordinates[1]) {
            aMapData.push({
              ...e,
              lat: e.coordinates[0],
              lng: e.coordinates[1],
            });
          }
        });
        setMapData(aMapData);
        // Set marker position and center of the map
        if (aMapData[0]) {
          setMapLatLng(aMapData[0]);
        } else {
          setMapLatLng({
            lat: 33.38602578260848,
            lng: 72.2310296875,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching Map data:", error);
      });
  };

  // Handle the map load
  const onLoad = (map) => {
    let heatMapData = mapData.map((item) => {
      return { lat: item.lat, lng: item.lng };
    });

    // Initialize the heatmap layer
    const heatmap = new window.google.maps.visualization.HeatmapLayer({
      data:
        heatMapData &&
        heatMapData.map(
          (point) => new window.google.maps.LatLng(point.lat, point.lng)
        ),
      map: map, // Attach the heatmap to the map
      radius: 20, // Adjust radius to control the spread of heatmap points
    });

    // Store the heatmap layer reference for potential future updates or removals
    heatmapLayerRef.current = heatmap;
  };

  // Handle the map unmount
  const onUnmount = () => {
    console.log("Map Unmounted");
  };

  // Handle loading and error states
  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded)
    return (
      <div>
        <ChartLoader />
      </div>
    );
  return (
    <div class="highChart-component">
      <GoogleMap
        key={mapData}
        mapContainerStyle={containerStyle}
        center={mapLatLng}
        zoom={6}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          zoomControlOptions: { position: 5 },
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: true,
          zoomControlOptions: { position: 5 },
          fullscreenControl: false,
          fullscreenControlOptions: { position: 5 },
          restriction: {
            latLngBounds: {
              north: 85,
              south: -85,
              west: -180,
              east: 180,
            },
          },
          styles: silverTheme,
        }}
      >
        {/* <Marker position={mapLatLng} /> *IN-7445- commented to remove marker and zoom out to view the map datapoints*/}
      </GoogleMap>
    </div>
  );
};

export default App;
